import { HttpErrorResponse } from '@angular/common/http';
import { Component, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { Subject, Subscription } from 'rxjs';
import { Messages } from 'src/app/constants/messages';
import {
  ResponseModel,
  ThresholdEditModel,
  ThresholdEditPayloadModel
} from 'src/app/model';
import { ServicecallService } from 'src/app/services/servicecall.service';
import { FormService } from '../../services';
import { thresholdValidator } from './threshold.validator';

@Component({
  selector: 'app-threshold-edit',
  templateUrl: './threshold-edit.component.html',
  styleUrls: ['./threshold-edit.component.css']
})
export class ThresholdEditComponent implements OnInit, OnDestroy {

  @Input() loading: boolean = true;

  @Input()
  set threshold(value: ThresholdEditModel) {
    this._threshold = value;
    this._createForm(value);
  }

  get threshold(): ThresholdEditModel {
    return this._threshold;
  }

  @Output() valueChanged = new Subject<boolean>();

  readonly MESSAGES = Messages;

  private _threshold: ThresholdEditModel;

  // Form
  editForm: FormGroup;
  isFormVisible: boolean = false;

  // Subscription
  private _thresholdSubscription: Subscription;

  constructor(
    private _apiService: ServicecallService,
    private _formBuilder: FormBuilder,
    private _formService: FormService
  ) { }

  ngOnInit(): void { }

  ngOnDestroy(): void {
    this._thresholdSubscription?.unsubscribe();
  }

  /**
   * Determines whether edit click on
   */
  onEditClick() {
    this._setFormVisibility(true);
  }

  /**
   * Determines whether form cancel on
   */
  onFormCancel() {
    this._setFormVisibility(false);
    this._loadDefaultFormData();
  }

  /**
   * Determines whether form submit on
   * @returns
   */
  onFormSubmit() {
    if (this.editForm.invalid) {
      return;
    }
    this._setThreshold();
  }

  /**
   * Creates form
   * @param value
   */
  private _createForm(value: ThresholdEditModel) {
    // Filter form
    this.editForm = this._formBuilder.group(
      {
        lowerLimit: [value?.threshold?.lowerLimit, Validators.required],
        upperLimit: [value?.threshold?.upperLimit, Validators.required]
      },
      {
        validators: [thresholdValidator]
      }
    );
    // Mark startDate, endDate as dirty
    this._formService.setFieldsDirtyOrPristine(this.editForm, ['lowerLimit', 'upperLimit'], true);
  }

  /**
   * Sets threshold
   */
  private _setThreshold() {
    this._setFormVisibility(false);
    // Filter
    const _filterPayload: ThresholdEditPayloadModel = {
      entityId: this.threshold?.entityId,
      attributeName: this.threshold?.attributeName,
      threshold: {
        lowerLimit: +this.editForm.get('lowerLimit').value ?? 0,
        upperLimit: +this.editForm.get('upperLimit').value ?? 0
      }
    };
    this.valueChanged?.next(true);
    // API call    
    this._thresholdSubscription = this._apiService.setMappingAttribute(_filterPayload, false)
    .subscribe({
      next: (result: ResponseModel<void>) => { 
        this.valueChanged?.next(true);
      },
      error: (errorResponse: HttpErrorResponse) => {
        this._apiService.toasterService({ type: 'Error', msg: errorResponse?.error?.response?.message });
      }
    });
  }

  /**
   * Loads default form data
   */
  private _loadDefaultFormData() {
    this.editForm.patchValue({
      lowerLimit: this.threshold?.threshold?.lowerLimit ?? 0,
      upperLimit: this.threshold?.threshold?.upperLimit ?? 0,
    });
  }

  /**
   * Sets form visibility
   * @param flag
   */
  private _setFormVisibility(flag: boolean) {
    this.isFormVisible = flag;
  }

}
